import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { visitRequest } from '@services/VisitRequest/VisitRequest';

export interface SendOtpVariables {
  requestId: string;
  recaptchaToken: string;
}

export const useVisitRequestSendOTP = () => {
  return useMutation<unknown, AxiosError, SendOtpVariables>(
    async ({ requestId, recaptchaToken }: SendOtpVariables) => {
      const { data } = await visitRequest.sendOTP({ requestId, recaptchaToken });
      return data;
    }
  );
};
